<template>
  <el-card>
    <el-form ref="searchForm" :model="searchForm" class="global-form" :inline="true">
      <el-form-item>
        <el-select v-model="searchForm.projectId" clearable placeholder="项目名称" @change="projectChange">
          <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="contractId">
        <el-select :disabled="!searchForm.projectId" clearable v-model="searchForm.contractId" placeholder="养护合同">
          <el-option v-for="(item, index) in yhContractList" :key="index" :label="item.contractName"
            :value="item.contractId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker v-model="dateArr" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" @change="dateChange">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="medium" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="mb20">
      <el-button type="primary" icon="el-icon-plus" @click="onAdd">新增</el-button>
    </div>
    <el-table ref="table" class="global-table" stripe v-loading="loading" :data="tableData" max-height="550px">
      <el-table-column label="项目名称" prop="projectName" show-overflow-tooltip></el-table-column>
      <el-table-column label="养护合同" prop="contractName" show-overflow-tooltip></el-table-column>
      <el-table-column label="计划回款日期" prop="planBackDate" show-overflow-tooltip></el-table-column>
      <el-table-column label="计划回款金额（元）" prop="planBackAmount" show-overflow-tooltip></el-table-column>
      <el-table-column label="实际回款日期" prop="actualBackDate" show-overflow-tooltip></el-table-column>
      <el-table-column label="实际回款金额（元）" prop="actualBackAmount" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="180px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="onDetails(row)">查看</el-button>
          <el-button type="text" @click="onEdit(row)">编辑</el-button>
          <el-button type="text" @click="onDelete(row.backId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <global-pagination :total="total" :current-page.sync="page" :page-size.sync="size" @current-change="loadData"
      @size-change="loadData"></global-pagination>

    <el-dialog :visible.sync="dialogVisible" :title="formData.backId ? '编辑回款' : '新增回款'" width="800px">
      <el-form class="global-form2" :model="formData" ref="form" :rules="rules" label-width="150px">
        <el-form-item label="项目名称" prop="projectId">
          <el-select v-model="formData.projectId" placeholder="请选择所属项目" @change="projectChange2">
            <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
              :value="item.projectId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="养护合同" prop="contractId">
          <el-select v-model="formData.contractId" placeholder="请选择养护合同" @change="loadPlanBackList">
            <el-option v-for="(item, index) in yhContractList2" :key="index" :label="item.contractName"
              :value="item.contractId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="plan" prop="planBackId" label="回款计划">
          <el-table :data="planBackList" border>
            <el-table-column width="40">
              <template v-slot="{ row }">
                <el-radio v-model="formData.planBackId" :label="row.planBackId">&nbsp;</el-radio>
              </template>
            </el-table-column>
            <el-table-column prop="planBackDate" label="计划回款日期"></el-table-column>
            <el-table-column prop="planBackAmount" label="计划回款额（元）"></el-table-column>
            <el-table-column prop="actualBackAmount" label="已回款额（元）"></el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item prop="actualBackDate" label="实际回款日期">
          <el-date-picker v-model="formData.actualBackDate" value-format="yyyy-MM-dd" type="date"
            placeholder="请选择实际回款日期"></el-date-picker>
        </el-form-item>
        <el-form-item prop="actualBackAmount" label="实际回款金额（元）">
          <el-input v-model="formData.actualBackAmount" placeholder="请输入实际回款金额"></el-input> 元
        </el-form-item>
        <el-form-item prop="fileList" label="附件">
          <file-upload v-model="formData.fileList"
            accept=".jpg,.jpeg,.png,.pdf,.ppt,.pptx.doc,.docx,.xls,.xlsx"></file-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">提交</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible2" title="回款详情" width="800px">
      <el-form class="global-form2" label-width="150px">
        <el-form-item label="项目名称" prop="projectId">
          {{ formData.projectName }}
        </el-form-item>
        <el-form-item label="养护合同" prop="projectId">
          {{ formData.contractName }}
        </el-form-item>
        <el-form-item class="plan" prop="planBackId" label="回款计划">
          <el-table :data="planBackList" border>
            <el-table-column prop="planBackDate" label="计划回款日期"></el-table-column>
            <el-table-column prop="planBackAmount" label="计划回款额（元）"></el-table-column>
            <el-table-column prop="actualBackAmount" label="已回款额（元）"></el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item prop="actualBackDate" label="实际回款日期">
          {{ formData.actualBackDate }}
        </el-form-item>
        <el-form-item prop="actualBackAmount" label="实际回款金额（元）">
          {{ formData.actualBackAmount }} 元
        </el-form-item>
        <el-form-item prop="fileList" label="附件">
          <file-upload readonly disabled v-model="formData.fileList"
            accept=".jpg,.jpeg,.png,.pdf,.ppt,.pptx.doc,.docx,.xls,.xlsx"></file-upload>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-card>
</template>

<script>
import { deepClone } from '@/utils/util'
import { twoDecimal } from '@/utils/validate'
import FileUpload from '@/components/FileUpload.vue'
export default {
  name: "CollectionManage",
  components: {
    FileUpload
  },
  data() {
    return {
      dateArr: [],
      page: 1,
      size: 10,
      total: 0,
      loading: false,
      tableData: [],
      searchForm: {
        projectId: '',
        startTime: '',
        endTime: '',
        contractId: ''
      },
      formData: {
        projectId: '', // 项目ID
        contractId: '', // 养护合同ID
        planBackId: '', // 回款计划ID
        actualBackDate: '', // 实际回款日期
        actualBackAmount: '', // 实际回款金额
        fileList: [] // 附件列表
      },
      rules: {
        projectId: [
          { required: true, message: '请选择项目名称' }
        ],
        contractId: [
          { required: true, message: '请选择项目名称' }
        ],
        planBackId: [
          { required: true, message: '请选择回款计划' }
        ],
        actualBackDate: [
          { required: true, message: '请选择实际回款日期' }
        ],
        actualBackAmount: [
          { required: true, message: '请输入实际回款金额' },
          { validator: twoDecimal }
        ],
      },
      dialogVisible: false,
      dialogVisible2: false,
      yhContractList: [],
      yhContractList2: [],
      planBackList: []
    }
  },
  computed: {
    projectList() {
      return this.$store.state.projectList
    }
  },
  watch: {},
  created() {
    this._tempRow = null
    this.loadData()
    this.loadDict()
  },
  methods: {
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.operate.selectBackByPage, {
        page: this.page,
        size: this.size,
        ...this.searchForm,
      }).then((res) => {
        this.total = res.total || 0
        this.tableData = res.list || []
      }).finally(() => {
        this.loading = false
      })
    },
    projectChange(val) {
      this.loadyhContractList(val).then(res => {
        this.searchForm.contractId = ''
        this.yhContractList = res || []
      })
    },
    loadyhContractList(val) {
      return this.$axios.get(this.$apis.operate.selectContractList, {
        projectId: val
      })
    },
    projectChange2(val) {
      this.loadyhContractList(val).then(res => {
        this.formData.contractId = ''
        this.yhContractList2 = res || []
      })
    },
    loadPlanBackList(contractId) {
      this.$axios.get(this.$apis.operate.selectPlanBackListByContractId, {
        contractId
      }).then(res => {
        this.planBackList = res || []
      })
    },
    loadDetails(backId) {
      return this.$axios.get(this.$apis.operate.selectBackByBackId, {
        backId
      }).then(res => {
        this.formData = res
        this.loadyhContractList(this.formData.projectId).then(res => {
          this.yhContractList2 = res || []
        })
        this.loadPlanBackList(this.formData.contractId)
      })
    },
    dateChange(date) {
      if (date) {
        this.searchForm.startTime = date[0]
        this.searchForm.endTime = date[1]
      } else {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
      }
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    loadDict() {
      this.$axios.get(this.$apis.common.selectDicByList, { dicType: 'indirectType' }).then(res => {
        this.indirectTypeList = res.indirectType || []
      })
    },
    indirectTypeChange(val, row) {
      const data = this.indirectTypeList.find(item => item.dicCode === val)
      row.indirectTypeName = data.dicValue
    },
    onAdd() {
      this.formData = {
        projectId: '', // 项目ID
        contractId: '', // 养护合同ID
        planBackId: '', // 回款计划ID
        actualBackDate: '', // 实际回款日期
        actualBackAmount: '', // 实际回款金额
        fileList: [] // 附件列表
      }
      this.planBackList = []
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    onEdit(row) {
      this.loadDetails(row.backId).then(() => {
        this.dialogVisible = true
      })
    },
    onDetails(row) {
      this.loadDetails(row.backId).then(() => {
        this.dialogVisible2 = true
      })
    },
    onDelete(backId) {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.operate.deleteBack, { backId }).then(() => {
          this.$message.success('删除成功')
          this.onSearch()
        })
      })
    },
    onSubmit() {
      console.log('formData', this.formData)
      this.$refs.form.validate().then(() => {
        let url = this.$apis.operate.insertBack
        if (this.formData.backId) {
          url = this.$apis.operate.updateBack
        }
        const formData = deepClone(this.formData)
        delete formData.projectId
        delete formData.contractId
        this.$axios.post(url, formData).then(() => {
          this.$message.success('提交成功')
          this.dialogVisible = false
          this.onSearch()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.plan {
  ::v-deep {
    .el-form-item {
      margin-bottom: 0;

      .el-input,
      .el-select {
        width: 100% !important;
      }
    }
  }
}
</style>
